import { Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";

// Types
import { IState } from "@/store";
import { IBrand } from "@/models/brands";

@Component({
  computed: {
    ...mapState({
      brand(state: IState) {
        return state.brand;
      }
    })
  }
})
export default class BrandsStore extends Vue {
  // State

  public brand!: IBrand;

  // Brand id

  public get brandId() {
    return this.$_.get(this.brand, "id");
  }

  // Price list

  public get defaultPriceListId() {
    return this.$_.get(this.brand, "pricelist_id");
  }

  // Currencies

  public get brandCurrencyId() {
    return this.$_.get(this.brand, "currency_id");
  }

  public get brandCurrencies() {
    return this.$_.orderBy(this.$_.get(this.brand, "currencies"), [
      "name",
      "asc"
    ]);
  }

  public get brandCurrency() {
    return this.$_.find(this.brandCurrencies, ["id", this.brandCurrencyId]);
  }
}
